import {Stack, Title} from '@mantine/core';
import {DisplayUserState} from '../DisplayUserState';
import {useAccounts} from '../../accounts/hooks/useAccounts';
import {useEffect} from 'react';

export const UserStateTab = () => {
    const {accounts, handleFetchAccounts} = useAccounts();

    useEffect(() => {
        handleFetchAccounts();
    }, []);

    return (
        <Stack gap="md">
            <Title order={2}>User State</Title>
            <DisplayUserState accounts={accounts} enabled={true} />
        </Stack>
    );
};
